/**
 * Format a number as Dutch locale currency (EUR).
 *
 * @example formatCurrency(963000)    → '€ 963.000'
 * @example formatCurrency(963000, 2) → '€ 963.000,00'
 */
export const formatCurrency = (amount: number, fractionDigits: number = 0): string => {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
};
